import type { StructuredContent } from './types';

export const footerContent: StructuredContent[] = [
  {
    host: 'www.sembo.co.uk',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.co.uk/our-policies',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.co.uk/travel-conditions',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.co.uk/travel-guarantee',
        },
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://www.sembo.co.uk/about-us',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.co.uk/places',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.co.uk/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.se',
    content: [
      [
        {
          text: 'Org nr: 556529-1795',
        },
        {
          text: 'Momsreg. nr: SE556529179501',
        },
        {
          text: 'Styrelsens säte: Helsingborg',
        },
      ],
      [
        {
          text: 'Resevillkor',
          href: 'https://www.sembo.se/resevillkor',
        },
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://www.sembo.se/om-oss',
        },
        {
          text: 'Jobba på Sembo',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.se/resegaranti',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.se/resmal',
        },
      ],
      [
        {
          text: 'EU:s svartlistade flygbolag',
          href: 'http://ec.europa.eu/transport/modes/air/safety/air-ban/index_sv.htm',
        },
        {
          text: 'Lufttrafikföretags skadeståndsansvar vid olyckor',
          href: 'http://eur-lex.europa.eu/LexUriServ/LexUriServ.do?uri=OJ:L:2002:140:0002:0005:EN:PDF',
        },
        {
          text: 'Våra policies',
          href: 'https://www.sembo.se/vara-policies',
        },
      ],
      [
        {
          text: 'Sembonus program',
          href: 'https://www.sembo.se/sembonus',
        },
        {
          text: 'Få erbjudanden, tips och nyheter. Anmäl dig till vårt nyhetsbrev',
          href: 'https://www.sembo.se/nyhetsbrev',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.se/resor/presentkort',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.dk',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://www.sembo.dk/om-os',
        },
        {
          text: `Rejsebetingelser`,
          href: 'https://www.sembo.dk/rejsebetingelser',
        },
        {
          text: 'Arbejde hos Sembo',
          href: 'https://career.sembo.com',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.dk/rejsegaranti',
        },
        {
          text: 'Vores policies',
          href: 'https://www.sembo.dk/vores-policies',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.dk/rejsemaal',
        },
      ],
      [
        {
          text: 'Sembonus',
          href: 'https://www.sembo.dk/sembonus',
        },
        {
          text: 'Få tilbud, tips og nyheder. Tilmeld dig vores nyhedsbrev',
          href: 'https://www.sembo.dk/nyhedsbrev',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.dk/rejser/gavekort',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.de',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 HELSINGBORG, SCHWEDEN',
        },
        {
          text: 'Steuer-Nr.: 556529-1795',
        },
        {
          text: 'Sitz der Gesellschaft: Helsingborg',
        },
      ],
      [
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://www.sembo.de/ueber-uns',
        },
        {
          text: 'Datenschutzerklärung',
          href: 'https://www.sembo.de/unsere-richtlinien',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.de/reisebedingungen',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.de/reisegarantie',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.de/reiseziele',
        },
      ],
      [
        {
          text: 'Registrieren Sie sich für unseren Newsletter',
          href: 'https://www.sembo.de/newsletter',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.at',
    content: [
      [
        {
          text: 'Box 1324, 251 13 HELSINGBORG',
        },
        {
          text: 'Steuer-Nr.: 556529-1795',
        },
        {
          text: 'Sitz der Gesellschaft: Helsingborg',
        },
      ],
      [
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://www.sembo.at/ueber-uns',
        },
        {
          text: 'Datenschutzerklärung',
          href: 'https://www.sembo.at/unsere-richtlinien',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.at/reisebedingungen',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.at/reisegarantie',
        },
      ],
      [
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.at/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.no',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 HELSINGBORG, SCHWEDEN',
        },
        {
          text: 'Registreringsnummer: 556529-1795',
        },
        {
          text: 'Registrert kontor: Helsingborg',
        },
      ],
      [
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://www.sembo.no/om-oss',
        },
        {
          text: 'Vare policies',
          href: 'https://www.sembo.no/vare-policies',
        },
        {
          text: 'Reisevilkår',
          href: 'https://www.sembo.no/reisevilkaar',
        },
      ],
      [
        {
          text: 'Work at sembo',
          href: 'https://career.sembo.se/',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.no/reisegaranti',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.no/reisemal',
        },
      ],
      [
        {
          text: 'Sembonus',
          href: 'https://www.sembo.no/sembonus',
        },
        {
          text: 'Få tilbud, tips og nyheter. Abonner på nyhetsbrevet.',
          href: 'https://www.sembo.no/bestill-och-ladda-ner/abonner-paa-sembos-nyhetsbrev.aspx',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.no/reiser/gavekort',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.es',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, Suecia',
        },
        {
          text: 'Número de registro: 556529-1795',
        },
        {
          text: 'Oficina registrada: Helsingborg, Suecia',
        },
      ],
      [
        {
          microcopy: 'explore.footer.privacyPolicy',
          href: 'https://www.sembo.es/nuestras-politicas',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.es/condiciones-de-viaje',
        },
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://www.sembo.es/sobre-nosotros',
        },
        {
          text: 'Trabaja en Sembo',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.es/garantia-viaje',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.es/lugares',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.es/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.hu',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SVÉDORSZÁG',
        },
        {
          text: 'Regisztrációs szám: 556529-1795',
        },
        {
          text: 'Székhely: Helsingborg, Svédország',
        },
      ],
      [
        {
          text: 'Adatvédelmi irányelvek',
          href: 'https://www.sembo.hu/szabalyzataink',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.hu/utazasi-feltetelek',
        },
        {
          text: 'Munka a Sembonál',
          href: 'https://career.sembo.se/',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.hu/utazasi-garancia',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.hu/helyek',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.hu/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.com',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.com/our-policies',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.com/travel-conditions',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.com/travel-guarantee',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.com/places',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.com/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.nl',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, ZWEDEN',
        },
        {
          text: 'Registratie nummer: 556529-1795',
        },
        {
          text: 'Statutaire zetel: Helsingborg, Zweden',
        },
      ],
      [
        {
          text: 'Privacybeleid',
          href: 'https://www.sembo.nl/onze-richtlijnen',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.nl/reisvoorwaarden',
        },
        {
          text: 'Werk bij Sembo',
          href: 'https://career.sembo.se/',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.nl/reisgarantie',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.nl/plaatsen',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.nl/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.ie',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.ie/our-policies',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.ie/travel-conditions',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se/',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.ie/travel-guarantee',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.ie/places',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.ie/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.fi',
    content: [
      [
        {
          text: 'Stena Line Travel Group AB, Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
      ],
      [
        {
          text: 'Tietoa Sembosta',
          href: 'https://www.sembo.fi/meista',
        },
        {
          text: 'Tietosuojaseloste',
          href: 'https://www.sembo.fi/toimintaperiaatteemme',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.fi/matkaehdot',
        },
        {
          text: 'Työskentele Sembolla',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.fi/matkatakuu',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.fi/matkakohde',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.fi/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.fr',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, Suède',
        },
        {
          text: 'Numéro de registre: 556529-1795',
        },
        {
          text: 'Siège social: Helsingborg, Suède',
        },
      ],
      [
        {
          text: 'Politique de confidentialité',
          href: 'https://www.sembo.fr/nos-politiques',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.fr/conditions-de-voyage',
        },
        {
          text: 'Travailler à Sembo',
          href: 'http://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.fr/garantie-voyage',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.fr/lieux',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.nz',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.nz/our-policies',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.nz/travel-conditions',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.nz/travel-guarantee',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.nz/places',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.nz/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.ca',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.ca/our-policies',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.ca/travel-conditions',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.ca/travel-guarantee',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.ca/places',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.ca/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.com.au',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.com.au/our-policies',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.com.au/travel-conditions',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se/',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.com.au/travel-guarantee',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.com.au/places',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.com.au/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'ch.sembo.com',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 HELSINGBORG, SCHWEDEN',
        },
        {
          text: 'Steuer-Nr.: 556529-1795',
        },
        {
          text: 'Sitz der Gesellschaft: Helsingborg',
        },
      ],
      [
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://ch.sembo.com/ueber-uns',
        },
        {
          text: 'Datenschutzerklärung',
          href: 'https://ch.sembo.com/unsere-richtlinien',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://ch.sembo.com/reisebedingungen',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://ch.sembo.com/reisegarantie',
        },
      ],
      [
        {
          microcopy: 'explore.destinations',
          href: 'https://ch.sembo.com/reiseziele',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.pl',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, Szwecja',
        },
        {
          text: 'Nr VAT: 556529-1795',
        },
        {
          text: 'Siedziba zarządu: Helsingborg, Szwecja',
        },
      ],
      [
        {
          text: 'Polityka prywatności',
          href: 'https://www.sembo.pl/nasze-zasady',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.pl/warunki-podrozy',
        },
        {
          text: 'Kariera',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.pl/gwarancja-podrozy',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.pl/miejsca',
        },
        {
          microcopy: 'explore.navigation.giftCard',
          href: 'https://www.sembo.pl/d/giftcertificate/giftcertificate.aspx',
        },
      ],
    ],
  },
  {
    host: 'it.sembo.com',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SVEZIA',
        },
        {
          text: 'Numero di registrazione: 556529-1795',
        },
        {
          text: 'Sede legale: Helsingborg, Svezia',
        },
      ],
      [
        {
          microcopy: 'explore.footer.privacyPolicy',
          href: 'https://it.sembo.com/le-nostre-politiche',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://it.sembo.com/condizioni-di-viaggio',
        },
        {
          text: 'Lavora con noi',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://it.sembo.com/garanzia-di-viaggio',
        },
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://it.sembo.com/chi-siamo',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://it.sembo.com/destinazioni',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.eu',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.eu/our-policies',
        },
        {
          text: `Travel Conditions`,
          href: 'https://www.sembo.eu/travel-conditions',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.eu/travel-guarantee',
        },
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://www.sembo.eu/about-us',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.eu/places',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.pt',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SUÉCIA',
        },
        {
          text: 'Número de registro: 556529-1795',
        },
        {
          text: 'Sede registrada: Helsingborg, Suécia',
        },
      ],
      [
        {
          text: 'Política de Privacidade',
          href: 'https://www.sembo.pt/nossas-politicas',
        },
        {
          text: 'Condições de Viagem',
          href: 'https://www.sembo.pt/condicoes-de-viagem',
        },
        {
          text: 'Trabalhe na Sembo',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.pt/garantia-viagem',
        },
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://www.sembo.pt/sobre-nos',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.pt/lugares',
        },
      ],
    ],
  },
  {
    host: 'tr.sembo.com',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, İSVEÇ',
        },
        {
          text: 'Sicil numarası: 556529-1795',
        },
        {
          text: 'Tescilli ofis: Helsingborg, İsveç',
        },
      ],
      [
        {
          microcopy: 'explore.footer.privacyPolicy',
          href: 'https://tr.sembo.com/politikalarimiz',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://tr.sembo.com/seyahat-kosullari',
        },
        {
          text: "Sembo'da Çalışın",
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://tr.sembo.com/seyahat-garantisi',
        },
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://tr.sembo.com/hakkimizda',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://tr.sembo.com/yerler',
        },
      ],
    ],
  },
  {
    host: 'www.sembo.be',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, ZWEDEN',
        },
        {
          text: 'Registratie nummer: 556529-1795',
        },
        {
          text: 'Statutaire zetel: Helsingborg, Zweden',
        },
      ],
      [
        {
          microcopy: 'explore.footer.privacyPolicy',
          href: 'https://www.sembo.be/onze-richtlijnen',
        },
        {
          microcopy: 'explore.footer.travelConditions',
          href: 'https://www.sembo.be/reisvoorwaarden',
        },
        {
          text: 'Werk bij Sembo',
          href: 'https://career.sembo.se',
        },
        {
          microcopy: 'explore.navigation.travelGuarantee',
          href: 'https://www.sembo.be/reisgarantie',
        },
        {
          microcopy: 'explore.footer.aboutUs',
          href: 'https://www.sembo.be/over-ons',
        },
        {
          microcopy: 'explore.destinations',
          href: 'https://www.sembo.be/plaatsen',
        },
      ],
    ],
  },
];
